import classnames from 'classnames';
import { FC, useMemo, useState } from 'react';
import {
  dataBtnsPublishersFormats,
  dataBtnsPublishersFormatsDesktop,
} from '../../../../../shared/lib/constants/data-btns-formats';
import { BlockHeader, SliderBlock } from '../../../../../shared/lib/ui';
import S from './Formats.module.scss';
import { useTranslation } from 'react-i18next';

export const Formats: FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  const [currentId, setCurrentId] = useState(1);

  const info = useMemo(() => {
    const defaultResponse = {
      subtitle: t('webmaster.formats_section.slider.subtitle'),
      descr: t('webmaster.formats_section.slider.description'),
      mobile: '50-120₽',
      desktop: '75-150₽',
    };

    switch (currentId) {
      case 1:
        return defaultResponse;
      case 2:
        return {
          subtitle: t('webmaster.formats_section.native.subtitle'),
          descr: t('webmaster.formats_section.native.description'),
          mobile: '80-200₽',
          desktop: '85-250₽',
        };
      case 3:
        return {
          subtitle: t('webmaster.formats_section.in_read.subtitle'),
          descr: t('webmaster.formats_section.in_read.description'),
          mobile: '100-250₽',
          desktop: '90-250₽',
        };
      case 4:
        return {
          subtitle: t('webmaster.formats_section.floor_ad.subtitle'),
          descr: t('webmaster.formats_section.floor_ad.description'),
          mobile: '30-80₽',
          desktop: '',
        };
      default:
        return defaultResponse;
    }
  }, [currentId, locale]);

  return (
    <section>
      <BlockHeader
        block={t('webmaster.formats_section.title')}
        title={<>{t('webmaster.formats_section.subtitle')}</>}
      />
      <SliderBlock
        lang={locale}
        id={currentId}
        title={
          <span className={S.Title}>
            {t('webmaster.formats_section.card_title')}
            <span>{info.subtitle}</span>
          </span>
        }
        descr={
          <>
            <span className={S.Description}>{info.descr}</span>
            <span className={S.Info}>
              {info.mobile && (
                <span>
                  <span className={classnames(S.InfoText, S.Subtitle)}>
                    mobile CPM
                  </span>
                  <span className={classnames(S.InfoText, S.InfoTitle)}>
                    {info.mobile}
                  </span>
                </span>
              )}
              {info.desktop && (
                <span>
                  <span className={classnames(S.InfoText, S.Subtitle)}>
                    desktop CPM
                  </span>
                  <span className={classnames(S.InfoText, S.InfoTitle)}>
                    {info.desktop}
                  </span>
                </span>
              )}
            </span>
          </>
        }
        mobileActions={dataBtnsPublishersFormats(locale || 'ru')}
        desktopActions={dataBtnsPublishersFormatsDesktop(locale || 'ru')}
        onChangeId={setCurrentId}
        color="green"
      />
    </section>
  );
};
